module.exports = __webpack_public_path__ + "img/r-cb6-r2-red.5b82fba0.gif";